import React, { SyntheticEvent } from 'react';
import styled, { css } from 'styled-components';

import { Spinner } from '@vimeo/bokeh';
import { Button } from '@vimeo/iris/components';

import * as translations from '../../../translations';
import { AlbumLayouts, VideoData, VimeoAlbumInfoResponse } from '../../types';

type LoadMoreButtonProps = {
  videoData: VideoData;
  album: VimeoAlbumInfoResponse;
  getMoreAlbumVideos: (e: SyntheticEvent) => void;
  isLoadingMore: boolean;
};

const LoadMoreButton = ({
  album,
  getMoreAlbumVideos,
  videoData,
  isLoadingMore,
}: LoadMoreButtonProps) => {
  const { layout, theme } = album;
  if (!videoData) {
    return null;
  }

  const { next } = videoData.paging;

  if (!next) {
    return null;
  }

  return (
    <LoadMoreButtonStyled
      fluid
      layout={layout}
      format={theme === 'dark' ? 'basic' : 'secondary'}
      variant={theme === 'dark' ? 'minimalTransparent' : 'solid'}
      style={{ marginBottom: '90px' }}
      onClick={getMoreAlbumVideos}
    >
      {isLoadingMore ? <Spinner color="gray.500" /> : translations.loadMore}
    </LoadMoreButtonStyled>
  );
};

export default LoadMoreButton;

const loadMorePlayerLayout = css`
  width: calc(100% - 6.5rem);
  margin-left: 3.25rem;
`;

const standardWidth = '1024px';

const loadMoreGridLayout = css`
  max-width: ${standardWidth};
`;

const LoadMoreButtonStyled = styled(Button)<{ layout: AlbumLayouts }>`
  ${(props) => (props.layout === 'player' ? loadMorePlayerLayout : loadMoreGridLayout)};
`;
